import { takeLatest, put } from "redux-saga/effects";

import configRepository, { GetServerAuditTrailResponse } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_GET_SERVER_AUDIT_TRAIL,
  TriggerGetServerAuditTrail,

  RESET_GET_SERVER_AUDIT_TRAIL
} from "./types";

import {
  getServerAuditTrailPending,
  getServerAuditTrailSuccess,
  getServerAuditTrailError
} from "./actions";
import { createCancellableSaga } from "../../../../../store/CancellableSaga";


function* handleTriggerGetServerAuditTrail(action: TriggerGetServerAuditTrail) {
  const { payload } = action;
  const { request } = payload;

  yield put(getServerAuditTrailPending());

  let response: GetServerAuditTrailResponse;

  try {
    response = yield configRepository.getServerAuditTrail(request);
  } catch (err) {
    yield put(getServerAuditTrailError());
    return;
  }

  yield put(getServerAuditTrailSuccess(response));
}


export function* watchGetServerAuditTrailSaga() {
  yield takeLatest(TRIGGER_GET_SERVER_AUDIT_TRAIL, handleTriggerGetServerAuditTrail);
}


export const getServerAuditTrailSaga = createCancellableSaga(
  watchGetServerAuditTrailSaga, RESET_GET_SERVER_AUDIT_TRAIL
);